import React from 'react'
import dayjs from 'dayjs'
import { Tooltip } from "antd"
import { useUserSettings } from 'api/hooks';

const DueDateCellRenderer = ({
  value,
  data, // get note
}) => {
  const { data: userSettings } = useUserSettings()
  if (!value) return null

  let dateFormat = userSettings?.date_format

  return (
    <div>
      <Tooltip title={data.note}>
        <div>
          {dayjs(value).format(dateFormat)}
        </div>
      </Tooltip>
    </div>
  )
};

export default DueDateCellRenderer
